import React, { useEffect, useState } from "react";
import Select from "@material-ui/core/Select/Select";
import MenuItem from "@material-ui/core/MenuItem/MenuItem";
import {
    Box,
    FormControl,
    FormHelperText,
    InputLabel,
} from "@material-ui/core";

export const ControlledSelect = ({
    label,
    id,
    value,
    options,
    onChange,
    hasError,
    includeAllFlag,
    isRequired
}) => {
    const [localValue, setLocalValue] = useState(value ?? "");
    useEffect(() => setLocalValue(value ?? ""), [value]);

    const handleChange = (event) => {
        const value = event.target.value;
        setLocalValue(value);
        if (onChange) {
            onChange(event);
        }
    };

    const renderAllOption = (
        <MenuItem value="ALL" key="all">
            All
        </MenuItem>
    );

    return (
        <Box sx={{ minWidth: 120 }}>
            <FormControl fullWidth>
                <InputLabel>{label} <span style={{color: "red"}}>{isRequired ? "*" : ""}</span></InputLabel>
                <Select
                    name={id}
                    value={localValue}
                    label={label}
                    onChange={handleChange}
                    required={isRequired}
                >
                    {includeAllFlag === "true" && renderAllOption}
                    {options?.map((option, index) => {
                        return (
                            <MenuItem
                                key={
                                    index +
                                    "-" +
                                    option.label +
                                    "-" +
                                    option.value
                                }
                                value={option.value}
                            >
                                {option.label}
                            </MenuItem>
                        );
                    })}
                </Select>
                {hasError && (
                    <FormHelperText style={{ color: "red" }}>
                        This is required!
                    </FormHelperText>
                )}
            </FormControl>
        </Box>
    );
};

export default ControlledSelect;
